import React, { useState } from "react";
import { CpeCreditData } from "../../services/event/cpe-credit"; 
import "./cpe-credit.css";

interface CpeCreditProps {
    className?: string;
}

const CpeCredit: React.FC<CpeCreditProps> = ({ className }) => {
    const [cfbId, setCfbId] = useState<string | undefined>(''); 
    const [loading, setLoading] = useState<boolean>(false); 
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false); // State to track if form is submitted

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsSubmitted(true); // Set the state to true when form is submitted

        setLoading(true);
        const payloadString = sessionStorage.getItem("attendeeinfo");

        if (payloadString) {
            const userData = JSON.parse(payloadString);

            const payload = {
                ...userData,
                cfbId
            };

            try {
                const response = await CpeCreditData(payload);
                console.log("API Response: ", response);
            } catch (error) {
                console.error("API Error: ", error instanceof Error ? error.message : error);
            } finally {
                setLoading(false);
            }
        } else {
            console.error("No attendee info found in session storage.");
            setLoading(false);
        }
    };

    return (
        <div className={className}>
            {isSubmitted ? (
                <div className="thank-you-message">
                    Thank you! Your CFP ID has been submitted.
                </div>
            ) : (
                <form onSubmit={handleSubmit}>
                    <div className="inner-from-wrapper">
                        <label htmlFor="cfb-id" className="title">
                            Enter your CFP ID number to qualify for CPE credit.
                        </label>
                        <input
                            className="input-type-wrapper"
                            type="text"
                            value={cfbId !== undefined ? cfbId : ""}
                            onChange={(e) => setCfbId(e.target.value)}
                            required
                        />
                        <button className="cpe-btn" type="submit" disabled={loading}>
                            {loading ? "Submitting..." : "Submit"}
                        </button>
                    </div>
                </form>
            )}
        </div>
    );
};

export default CpeCredit;
